<template>
    <PrimeDrawer v-model:visible="openFlyout" position="right" :pt:root="{'class': 'quickview-panel__overlay'}" :pt:header="{'style': 'display:none;'}">
        <div class="quickview-panel" ref="buystackFlyout">
            <div class="quickview-panel__header">
                <p class="paragraph-details">Quick Shop</p>
                <button class="quickview-panel__close" aria-label="Close Quick Shop" @click="closeFlyout()">
                    <CloseIcon role="presentation" />
                </button>
            </div>
            <div v-show="isLoading || quickViewErrorMessage">
                <div class="productDetails">
                    <div class="productDetails-content-container">
                        <p class="invalid-state" style="margin: 0 1.25rem;" v-if="quickViewErrorMessage">{{ quickViewErrorMessage }}</p>
                        <div class="productDetails-information">
                            <div class="skeleton" style="height:4rem; padding: 0;"></div>
                            <div class="skeleton" style="height:2rem; padding: 0;"></div>
                            <div class="skeleton" style="height:350px; padding: 0;"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="!isLoading && !quickViewErrorMessage" class="quickview-panel__content">
                <div class="productDetails">
                    <div class="productDetails-content-container">
                        <div class="productDetails-information">
                            <div class="headline-m headline">{{ fromProductDetailPage ? buyStackFlyoutData.product.item_name : quickView.product.item_name }}</div>
                            <div v-if="is_dealer" class="productDetails-b2b-price">
                                <span class="paragraph-feature">MAP: 
                                    <span class="productDetails-price-map title-l">
                                        {{productDetails.productPricing?.map_price ? `$${formatPrice(productDetails.productPricing?.map_price)}`: "N/A"}}
                                    </span>
                                </span>
                                <div v-if="is_dealer" class="divider-horizontal"></div>
                                <span class="paragraph-feature">MSRP: 
                                    <span class="productDetails-price-map title-l">
                                        {{productDetails.productPricing?.msrp_price ? `$${formatPrice(productDetails.productPricing?.msrp_price)}`: "N/A"}}
                                    </span>
                                </span>
                                <div v-if="canSeePricing" class="divider-horizontal"></div>
                                <span v-if="canSeePricing" class="paragraph-feature">Wholesale:
                                    <span class="productDetails-price-map title-l">
                                        {{productDetails.productPricing?.price_to_use_with_discount ? `$${formatPrice(productDetails.productPricing?.price_to_use_with_discount)}`: "N/A"}}
                                    </span>
                                    <span v-if="+productDetails.productPricing?.original_price > +productDetails.productPricing?.price_to_use_with_discount" class="productDetails-price-discount">
                                        ${{formatPrice(productDetails.productPricing?.original_price)}}
                                    </span>
                                </span>
                            </div>
                            <div v-else class="productDetails-price">
                                <span class="paragraph-feature">from&nbsp;</span>
                                <span class="productDetails-price-total title-l">${{formatPrice(productDetails.productPricing?.price_to_use_with_discount)}}</span>
                                <span v-if="+productDetails.productPricing?.original_price > +productDetails.productPricing?.price_to_use_with_discount" class="productDetails-price-discount">
                                    ${{formatPrice(productDetails.productPricing?.original_price)}}
                                </span>
                            </div>
                            <div class="productDetails-reviews">
                                <div class="productDetails-reviews_item title-s">Item #{{productDetails.selectedVariant ? productDetails.selectedVariant.rothcoItem.rothco_item_no : ""}}</div>
                            </div>
                            <!-- <div class="productDetails-discount_text paragraph-details">Extra 20% Off: Code SPRING | BOGO 50% Off</div> -->
                        </div>
                        <image-gallery-mobile ref="imageGalleryMobile" :productImages="productDetails.productLargeImages"/>
                        <ProductSpecGroup
                            v-for="(specGroup, key) in productDetails.buyStack"
                            :key="key"
                            :specGroup="specGroup"
                            :selectedVariantValues="productDetails.selectedVariantValues"
                            :variationValueAvailablity="productDetails.variationValueAvailablity"
                            :numSpecGroups="Object.keys(productDetails.buyStack ?? {}).length"
                            @add-variation-value="productDetails.addVariationValue($event)"
                            :color="props.color"
                        />

                        <div class="productDetails-sticky_footer">

                            <div v-if="!productDetails.inStock && !productDetails.nextMissingVariant && (productDetails.d2c_view_only == 0 || is_dealer )" :class="['productDetails-size_stock title-m', productDetails?.eta_color]">
                                {{ productDetails.etaInfo?.eta_message }}{{ productDetails.etaInfo?.eta_date ? " | ETA " + moment(productDetails.etaInfo?.eta_date).format("MM/DD/YY") : null }}
                            </div>
                            <div v-else class="productDetails-size_stock title-m text-inStockGreen">
                                <span v-if="is_dealer">
                                    {{canSeePricing ? `Your Price: ${formatPrice(productDetails.productPricing?.price_to_use_with_discount)}` : ''}}
                                    <span style="margin-left:2rem;">{{+productDetails.selectedVariant?.inventory_level >= 99 ? `99+` : +productDetails.selectedVariant?.inventory_level }} available</span>
                                </span>
                                <span v-else-if="productDetails.d2c_view_only == 0">In Stock & Ready to Ship</span>
                            </div>
                            
                            <div class="productDetails-actions">
                                <number-input v-if="productDetails.d2c_view_only == 0 || is_dealer" type="number" name="counter" id="quantity" class="productDetails-counter_input"  min="0" max="99999" step="1" v-model.natural.whole="productDetails.quantity" @wheel.prevent="blurOnWheel" />
                                <RothcoCta v-if="productDetails.d2c_view_only == 1 && !is_dealer" class="primary productDetails-order_btn" ctaType="button" :href="retailLocatorUrl" id="find_retailer_button">Find a Retailer near you</RothcoCta>
                                <button v-if="productDetails.nextMissingVariant" type="submit" class="disabled productDetails-submit_btn">{{ `Please Select Your ${productDetails.nextMissingVariant}` }}</button>
                                <RothcoCta 
                                    v-else-if="!productDetails.nextMissingVariant && productDetails.inStock"
                                    ctaType="button" :disabled="productDetails.quantity <= 0 || +productDetails?.totalPrice <= 0" preserve-scroll 
                                    :class="['productDetails-order_btn', (productDetails.quantity > 0 && +productDetails?.totalPrice > 0) ? 'primary' : 'disabled']" @click="addToCart()">
                                        Add to Cart{{ canSeePricing ? ` - $${formatPrice(productDetails.totalPrice)}` : '' }}
                                </RothcoCta>
                                <RothcoCta v-else-if="!productDetails.nextMissingVariant && !productDetails.inStock && productDetails.eta_date" class="primary productDetails-order_btn" ctaType="button" @click="openEmail()">{{ `Get Notified When It's ${productDetails.selectedVariant?.is_active == 1 ? "Back" : "Here"}` }}</RothcoCta>
                            </div>
                            <div class="productDetails-action_options" v-if="!fromProductDetailPage">
                                <Link as="div" class="productDetails-action quickview-only" @click="toggleBuystackFlyout(null)" :href="route('productDetail.show', [props.product_seo_name ?? ''])" :data="{
                                    color: selectedColor ? selectedColor : undefined,
                                }">
                                    <SeeInstructionsIcon alt="compare-icon" src="@icons/see-instructions.svg" />
                                    <div class="title-xs product-options">View Full Details</div>
                                </Link>
                                <div class="divider-horizontal"></div>
                                <div class="productDetails-action" @click="toggleFavorite()">
                                    <FavoriteIcon v-show="hasFavorite" alt="favorite-icon" />
                                    <SaveFavoriteIcon v-show="!hasFavorite" alt="favorite-icon" src="@icons/icon-save-favorite-pdp.svg" />
                                    <div class="title-xs product-options">{{ hasFavorite ? 'Remove from ' : 'Save to ' }}Favorites</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </PrimeDrawer>
</template>
<script lang="ts" setup>

    import { watch, inject, ref, computed } from 'vue';
    import moment from "moment";
    import _ from "lodash";
    import { router, Link } from "@inertiajs/vue3";
    // import { route } from "ziggy-js";
    import { useRouter } from "@/helpers/composables/useRouter";
    import ImageGalleryMobile from "@/components/ProductImageGalleryMobile.vue";
    import ProductSpecGroup from "@/components/ProductSpecGroup.vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { useLists } from "@/helpers/composables/useList";
    import { useProductDetails, fetchProductDetails } from "@/helpers/composables/useProductDetails";
    import { useSettingsStore } from "@/store/settings";
    import { useGenericStore } from "@/store/genericStore";
    import { createUseFavoritesStore } from "@/store/favorites";
    import { storeToRefs } from "pinia";
    import { usePage } from "@inertiajs/vue3";
    import { useSearchSpringCookiesStore } from "@/store/searchSpringCookies.ts";
    import ReceiveEmailModal from "@/components/ReceiveEmailModal.vue";
    import { useDialog } from 'primevue/usedialog';
    import { formatPrice, formatTotalPrice } from "@/helpers/composables/usePriceFormatting"
    import CartPreview from "@/components/cart/CartPreview.vue";
    import { onClickOutside } from "@vueuse/core";
    import CloseIcon from "@icons/closeIcon.svg";
    import SeeInstructionsIcon from "@icons/see-instructions.svg";
    import SaveFavoriteIcon from "@icons/icon-save-favorite-pdp.svg";
    import FavoriteIcon from "@icons/favorite-icon-product-card.svg";
    import useGoogleManager from '@/helpers/composables/google';
    const route:Function = inject('route');

    const props = defineProps({
        product_seo_name: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: ''
        },
        item_index: {
            type: [String,Number],
            default: null
        }
    })
    let { gtmViewItem, gtmAddToCartEvent } = useGoogleManager();


    const openFlyout = defineModel("visible",{
        type: Boolean,
        default: false
    });

    const buyStackFlyoutDataStore = useGenericStore('buyStackFlyoutDataStore');
    let { state:buyStackFlyoutData } = storeToRefs(buyStackFlyoutDataStore);

    const { is_dealer, user_id, isLoggedIn, quickView, isBuystackFlyoutOpened, isLoadingQuickView, quickViewErrorMessage, canSeePricing } = storeToRefs(useSettingsStore());
    const { setList, toggleFlyout, toggleBuystackFlyout, setNotificationMessage } = useSettingsStore();

    const isLoading = computed(()=>isLoadingQuickView.value);

    const { to } = useRouter({
        router,
        route
    });

    const closeFlyout = ()=>{
        toggleBuystackFlyout(null);
        openFlyout.value = false;
    }
    const buystackFlyout = ref(null);
    onClickOutside(buystackFlyout, ()=>{
        closeFlyout();
    });
    const productDetails = ref({
        seo_name: '',
        images: [],
        item_variations: [],
        item_specifications: [],
        prices: [],
        etaInfo: {}
    });

    const fromProductDetailPage = computed(()=>{
        return !!buyStackFlyoutData?.value?.product?.seo_name && buyStackFlyoutData?.value?.product?.seo_name == quickView.value.product_seo_name
    })
    let prices = computed(()=>{
        return quickView.value.prices;
    });
    if(fromProductDetailPage.value){
        productDetails.value = buyStackFlyoutData?.value;
    }else if(quickView.value.product != null){
        // fetch product here
        productDetails.value = useProductDetails({ product: quickView.value.product ? {...quickView.value.product, seo_name: quickView.value.product_seo_name} : {
            seo_name: props.product_seo_name ?? "",
            images: [],
            item_variations: [],
            item_specifications: [],
            prices: [],
            etaInfo: {},
        }, route: route, prices});
    }else{
        fetchProductDetails(quickView.value.product_seo_name);
    }

    watch([openFlyout, ()=>(quickView.value.product_seo_name)], ([newOpenState, newSeoName], [prevOpenState, prevSeoName])=>{
        if(newOpenState && newOpenState != prevOpenState){
            if(newSeoName && newSeoName != prevSeoName){
                if(newSeoName == buyStackFlyoutData?.value?.product?.seo_name){
                    productDetails.value = buyStackFlyoutData.value
                }else{
                    productDetails.value = fetchProductDetails(quickView.value.product_seo_name);
                }
            }
        }
    })

    let favoritesStore;
    let favoriteId;
    let hasFavorite;

    watch(()=>(quickView.value.product), (newVal, oldVal)=>{
        if(newVal.item_index  && newVal.item_index != oldVal.item_index){
            productDetails.value = useProductDetails({ product: newVal, route: route, prices });

            favoritesStore = createUseFavoritesStore(`favorite-${newVal.item_index}`, {
                item_index: productDetails.value.item_index, 
                user_id: user_id.value
            })();
            favoriteId = storeToRefs(favoritesStore).favoriteId;

            hasFavorite = computed(()=>{
                return ![0,null,'',undefined].includes(favoriteId.value)
            })

            addViewedProduct(quickView.value.product.product_line_code);
        }
    }, {deep: true})

    const handleAccountLogin = () => {
        toggleFlyout({
            type: 'info',
            headline: 'Adding to Favorites? ',
            message: 'Please log in to save your favorite items.',
        });
    };

    const toggleFavorite = ()=>{
        if(!isLoggedIn.value) {
            closeFlyout();
            handleAccountLogin();
            return;
        }
        hasFavorite.value ? favoritesStore.deleteFavorite() : favoritesStore.addFavorite();
    }

    let currentList = computed(() => {
        return usePage().props.current_list;
    });

    let { addToList } = useLists({ router, route });
    let searchSpringCookiesStore = useSearchSpringCookiesStore();
    let { addViewedProduct, addCartProduct } = searchSpringCookiesStore;
    let isCartPage = computed(()=>{
        return usePage().component === 'CartPage';
    });
    let addToCart = function () {
        if(productDetails.value.quantity <= 0 || +productDetails.value?.totalPrice <= 0) return;
        const variant = productDetails.value.selectedVariant;
        const price = productDetails.value.productPricing;
        const item = {
            source: import.meta.env.VITE_NORMAL_ORDERING_SOURCE,
            listId: currentList?.value?.list_id,
            current_unit_price: price?.price_to_use_with_discount,
            quantity: productDetails.value.quantity,
            item_variation_id: variant.item_variation_id
        };

        gtmAddToCartEvent({
            ...variant,
            price: price?.price_to_use_with_discount,
            quantity: productDetails.value.quantity,
            item: {
                name: productDetails.value.item_name,
            }
        })
        setNotificationMessage({
            message: `Adding to Cart`,
            type: 'default'
        })
        addToList(item, {
            afterFetch: () => {
                return new Promise((resolve) => {
                    setNotificationMessage(null);
                    closeFlyout();
                    addCartProduct(productDetails.value.product_line_code);
                    router.reload({
                        only: isCartPage.value ? ['current_list', 'last_added_item', 'list', 'list_items'] : ["current_list", "last_added_item"],
                        onSuccess: (data) => {
                            setList(usePage().props.current_list);
                            resolve(data);
                            openCartPreview();
                        }
                    });
                });
            }
        });   
    };
    const dialog = useDialog();
    let openEmail = () => {
        closeFlyout();
        dialog.open(ReceiveEmailModal, {
            props: {
                showHeader: false,
                modal: true
            },
            data: {
                itemVariationId: productDetails.value.selectedVariant?.item_variation_id ?? null
            }
        });
    };
    let openCartPreview = () => {
        dialog.open(CartPreview, {
            props: {
                showHeader: false,
                modal: false
            }
        });
    };

    router.on('start', (event) => {
        isLoading.value = true;
    })

    router.on('finish', (event) => {
        isLoading.value = false;
    })


    const blurOnWheel = (event) => {
        event.target.blur();
    }
    addViewedProduct(quickView.value.product.product_line_code);

    watch(()=>(isBuystackFlyoutOpened.value), (newVal) => {
        let chaportIntegration = document.getElementsByClassName('chaport-launcher-button');

        if (newVal) {
            if (chaportIntegration.length > 0) {
                chaportIntegration[0].classList.add('hidden');
            }
        }else{
            if (chaportIntegration.length > 0) {
                chaportIntegration[0].classList.remove('hidden');
            }
        }
    });

    let selectedColor = computed(()=>{
        return productDetails.value.selectedVariantValues?.find((value)=>value.specGroup.name.toLowerCase() == 'color')?.spec_value;
    });

    const imageGalleryMobile = ref();
    watch(()=>(productDetails.value.selectedVariantValues), (newVal)=>{
        imageGalleryMobile?.value?.backToStart();
    }, {deep: true})
    watch(productDetails.value.selectedVariant, (newVal)=>{
        if(newVal?.item_variation_id){
            gtmViewItem({
                ...newVal,
                item: {
                    name: productDetails.value.item_name,
                },
                price: productDetails.value.productPricing?.price_to_use_with_discount,
                quantity: productDetails.value.quantity,
            })
        }
    }, {deep: true})

</script>